import React from "react";
import { usePurchaseOrderLogModel } from "../purchaseOrderLogModel";
import { ISearchValue, SearchTypeEnum } from "@/components/YhPageHeader/Types";
import { YhPageHeader } from "@/components/YhPageHeader";
import { useDictModel } from "@/views/base/dict/dictModel";
import { DictCodeEnmu } from "@/types/VrmSaDictEnums";
import useGlobalModel from "@/model/globalModel";

export function PageHeader() {
    const {
        searchParam,
        updateSearchParam,
        resetSearchParam,
        loadData
    } = usePurchaseOrderLogModel();
    const { getSelectedDictOne } = useDictModel(() => []);
    const { shopAndOrg: { shopType }, allShopDs } = useGlobalModel();

    const searchFields = [
        {
            type: SearchTypeEnum.Input,
            placeholder: "采购批次号",
            fieldName: "batchCode"
        },
        {
            type: SearchTypeEnum.Input,
            placeholder: "供货单位",
            fieldName: "supplierName"
        },
        {
            type: SearchTypeEnum.Input,
            placeholder: "材料编码",
            fieldName: "materialCode",
        },
        {
            type: SearchTypeEnum.RangePicker,
            fieldName: "",
            rangePickerFieldName: ["fillingStartTime", "fillingEndTime"],
            placeholder: ["申请开始时间", "申请结束时间"],
            format: "YYYY-MM-DD",
        },
    ]

    return (
        <YhPageHeader
            title="采购部订单台账"
            size="small"
            //  
            searchValues={searchParam as ISearchValue}
            searchFields={searchFields}
            onChange={updateSearchParam}
            triggerSearch
            handleSearch={(val = {}) => loadData({ pageNum: 1 }, { ...searchParam, ...val })}
            handleReset={resetSearchParam}
        />
    );
}